<ng-template [ngIf]="selectedNestingGroup$ | async" let-selectedNestingGroup>
  <div
    class="multi-quota-nesting-table"
    *ngIf="selectedNestingGroup?.quotas?.length; else noNestedQuotas"
  >
    <div class="action-container mb-2">
      <p class="semi-bold-font title title-quota">
        {{ selectedNestingGroup?.id }}
      </p>
      <div class="nested-quota-actions">
        <button
          class="btn rounded-2 action-button px-4"
          color="primary"
          [ngClass]="{
            'btn-primary': selectedNestingGroup?.canResetTable
          }"
          [disabled]="!selectedNestingGroup?.canResetTable"
          (click)="resetTable()"
        >
          Reset Table
          <span>
            <i class="fa fa-rotate-left"></i>
          </span>
        </button>
        <button
          class="btn rounded-2 action-button px-4"
          [ngClass]="{
            'btn-primary': selecteds.length >= 1
          }"
          (click)="deleteCondition()"
          [disabled]="selecteds.length < 1"
        >
          Delete Quota
          <span class="ms-1">
            <i class="fa fa-trash"></i>
          </span>
        </button>
        <button
          *ngIf="isCombineQuotasEnabled"
          class="btn rounded-2 action-button px-4"
          [ngClass]="{
            'btn-primary': selecteds.length >= 2
          }"
          (click)="onCombineQuotas()"
          [disabled]="selecteds.length < 2"
        >
          Combine Quotas
          <span class="ms-1">
            <i class="fa fa-chain"></i>
          </span>
        </button>
      </div>
    </div>

    <div class="ps-ui-table-container">
      <ps-ui-table
        [data]="(nestedQuotaRecords$ | async) || []"
        [trackBy]="'buyer_quota_id'"
      >
        <ng-container
          psUiTableExpandableRow
          [manualClose]="true"
          [behavior]="'one'"
          [backGroundRowColor]="getRowHighlightColor"
        >
          <ng-container
            psUiTableCheckboxColumn
            [selectBy]="'buyer_quota_id'"
            [(selectedKeys)]="selecteds"
            [show]="true"
            [showInRow]="false"
            [showIndeterminate]="true"
            [hideFor]="(nestedQuotaGroupIds$ | async) || []"
          ></ng-container>
          <ng-container psUiTableColumn *ngIf="hasUnicornQuota">
            <ng-template psUiTableColumnCustomHeader>
              <!-- empty block -->
              <div class="double-header">&nbsp;</div>
            </ng-template>
            <ng-template
              psUiTableCellTemplate
              let-nestedQuota
              let-index="index"
            >
              <div
                class="setting-info float-start"
                *ngIf="surveyUnicorns.hasQuota(nestedQuota?.buyer_quota_id)"
              >
                <i
                  class="fa fa-exclamation-circle error-icon me-2"
                  aria-hidden="true"
                ></i>
                <p>
                  {{
                    QuotaConstants.UNICORN_NESTING_TOOLTIP
                      .HIGHLY_CHALLENGING_QUOTA
                  }}
                </p>
              </div>
            </ng-template>
          </ng-container>

          <ng-container psUiTableColumn width="65%">
            <ng-template psUiTableColumnCustomHeader>
              <div
                class="text-center bold-font double-header flex-wrapper qualification-container"
                *ngIf="
                  selectedQualifications$ | async as selectedQualifications
                "
              >
                <div
                  *ngFor="
                    let qualification of selectedQualifications;
                    let i = index
                  "
                  class="double-header"
                >
                  {{ qualification.qualification_name }}
                </div>
              </div>
            </ng-template>
            <ng-template psUiTableColumnCustomHeader>
              <!-- empty block -->
              <div class="double-header">&nbsp;</div>
            </ng-template>
            <ng-template
              psUiTableCellTemplate
              let-nestedQuota
              let-index="index"
            >
              <div
                class="text-center flex-wrapper qualification-container"
                *ngIf="
                  !nestedQuota?.individual_quotas?.length;
                  else quotaGroupTemplate
                "
              >
                <div
                  *ngFor="let eachCombinedKey of nestedQuota.combinedKey"
                  class="cell-block pl-2"
                >
                  {{ eachCombinedKey }}
                </div>
              </div>

              <ng-template #quotaGroupTemplate>
                <div class="flex-wrapper">
                  <div
                    *ngIf="
                      !nestedQuota.isQuotaTitleEdit;
                      else editQuotaTitleTemplate
                    "
                    class="cell-block quota-group-title-container"
                  >
                    <div
                      class="text-center"
                      *ngIf="selectedQualifications$ | async as qualifications"
                    >
                      {{ nestedQuota.quota_title }}
                      <button
                        type="button"
                        title="Edit Group Title"
                        class="btn p-0"
                        (click)="nestedQuota.isQuotaTitleEdit = true"
                      >
                        <i
                          class="fa fa-pencil quota-lg-font group-action-icon"
                        ></i>
                      </button>
                      <button
                        type="button"
                        title="Ungroup Quota"
                        class="btn p-0 ms-1"
                        (click)="OnUnGroupQuota(nestedQuota, index)"
                      >
                        <i
                          class="fa fa-chain-broken quota-lg-font group-action-icon"
                        ></i>
                      </button>
                    </div>
                  </div>
                  <ng-container
                    *ngIf="selectedQualifications$ | async as qualifications"
                  >
                    <ng-container
                      *ngFor="let item of qualifications; let i = index"
                    >
                      <div *ngIf="i > 0" class="cell-block pl-2"></div>
                    </ng-container>
                  </ng-container>
                </div>
                <ng-template #editQuotaTitleTemplate>
                  <ps-ui-input-with-confirmation
                    class="group-input"
                    [value]="nestedQuota.quota_title"
                    (confirm)="
                      onQuotaTitleUpdate(nestedQuota.buyer_quota_id, $event)
                    "
                    (cancel)="onResetEditState(nestedQuota, 'isQuotaTitleEdit')"
                  ></ps-ui-input-with-confirmation>
                </ng-template>
              </ng-template>
            </ng-template>

            <ng-template psUiColumnFooter>
              <p class="text-end bold-font m-0">Total goal remaining</p>
            </ng-template>
          </ng-container>

          <ng-container psUiTableColumn width="23%">
            <ng-template psUiTableColumnCustomHeader>
              <div
                class="text-center bold-font m-0 double-header allocation-container min-width-allocation"
              >
                Allocation
              </div>
            </ng-template>

            <ng-template psUiTableColumnCustomHeader>
              <div
                class="text-center bold-font double-header flex-wrapper horizontal-padding-7 allocation-container min-width-allocation"
              >
                <div class="text-center bold-font">#</div>
                <div class="text-center bold-font">%</div>
              </div>
            </ng-template>
            <ng-template psUiTableCellTemplate let-nestedQuota>
              <div
                class="flex-wrapper allocation-container min-width-allocation"
              >
                <div class="text-center">
                  <input
                    type="number"
                    class="rounded-2 text-center cell-input"
                    min="0"
                    placeholder="0"
                    [ngModel]="
                      nestedQuota.required_count || nestedQuota.number || 0
                    "
                    (focusout)="onQuotaCountUpdate(nestedQuota, $event)"
                    psUiInputRestriction="[0-9]"
                  />
                </div>

                <div class="text-center">
                  <input
                    type="number"
                    class="rounded-2 text-center cell-input"
                    min="0"
                    placeholder="0"
                    [ngModel]="nestedQuota.percentage || 0 | number : '1.0-0'"
                    (focusout)="onQuotaPercentageUpdate(nestedQuota, $event)"
                    psUiInputRestriction="[0-9]"
                  />
                  %
                </div>
              </div>
            </ng-template>
            <ng-template psUiColumnFooter let-nestedQuota>
              <div class="text-center bold-font footer-element w-50">
                {{ remainingAllocation }}
              </div>
            </ng-template>
          </ng-container>

          <ng-container psUiTableColumn width="3%">
            <ng-template psUiTableColumnCustomHeader>
              <div class="text-center bold-font double-header">Fielded</div>
            </ng-template>
            <ng-template psUiTableColumnCustomHeader>
              <!-- empty block -->
              <div class="double-header">&nbsp;</div>
            </ng-template>
            <ng-template psUiTableCellTemplate let-nestedQuota let-row="index">
              <div class="d-flex align-items-center">
                <span class="flex-1 text-center">
                  {{ nestedQuota.fielded || 0 }}
                </span>
              </div>
            </ng-template>
          </ng-container>
          <ng-container psUiTableColumn width="2%">
            <ng-template psUiTableColumnCustomHeader>
              <div class="text-center bold-font double-header"></div>
            </ng-template>
            <ng-template psUiTableCellTemplate let-nestedQuota let-row="index">
              <div class="d-flex align-items-center">
                <button
                  *ngIf="
                    !nestedQuota?.individual_quotas?.length;
                    else expandRowButton
                  "
                  class="btn p-0"
                  title="Delete Quota"
                  (click)="deleteQuota(nestedQuota.buyer_quota_id)"
                >
                  <i class="fa fa-trash"></i>
                </button>
                <ng-template #expandRowButton>
                  <ng-container *ngIf="expandable.expanded$ | async as state">
                    <button
                      *ngIf="!state.expanded(row)"
                      class="btn expandable-btn p-0"
                      (click)="onExpandRow(row)"
                    >
                      <i class="fa fa-sharp fa-thin fa-chevron-down"></i>
                    </button>
                    <button
                      *ngIf="state.expanded(row)"
                      class="btn expandable-btn p-0"
                      (click)="onRetractRow(row)"
                    >
                      <i class="fa fa-sharp fa-thin fa-chevron-up"></i>
                    </button>
                  </ng-container>
                </ng-template>
              </div>
            </ng-template>
          </ng-container>

          <ng-template psUiTableExpandableContent let-nestedQuota>
            <ng-container
              *ngTemplateOutlet="
                quotaGroupTable;
                context: { $implicit: nestedQuota }
              "
            ></ng-container>
          </ng-template>
        </ng-container>
      </ps-ui-table>
    </div>
  </div>

  <ng-template #noNestedQuotas>
    <div class="multi-quota-nesting-no-quotas">
      <div class="d-block text-center multi-quota-nesting-no-quotas-content">
        <div class="p-4">
          <svg
            width="44"
            height="39"
            viewBox="0 0 44 39"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M39.4688 0.6875H4.53125C2.30482 0.6875 0.5 2.49232 0.5 4.71875V34.2812C0.5 36.5077 2.30482 38.3125 4.53125 38.3125H39.4688C41.6952 38.3125 43.5 36.5077 43.5 34.2812V4.71875C43.5 2.49232 41.6952 0.6875 39.4688 0.6875ZM19.3125 32.9375H5.875V24.875H19.3125V32.9375ZM19.3125 19.5H5.875V11.4375H19.3125V19.5ZM38.125 32.9375H24.6875V24.875H38.125V32.9375ZM38.125 19.5H24.6875V11.4375H38.125V19.5Z"
              fill="#CEE4EF"
            />
          </svg>
        </div>
        <p class="quota-lg-font">
          To create a nested quota, select the criteria you want to nest from
          the options on the left side of the screen.
        </p>
      </div>
    </div>
  </ng-template>
</ng-template>

<ng-template #quotaGroupTable let-nestedQuota>
  <div class="nested-quota-group-table">
    <ps-ui-table [data]="nestedQuota.individual_quotas" [headless]="true">
      <ng-container psUiTableColumn width="2%" [minWidth]="35" [maxWidth]="35">
        <ng-template psUiTableCellTemplate let-quota>
          <div class="empty-block">&nbsp;</div>
        </ng-template>
      </ng-container>
      <ng-container psUiTableColumn *ngIf="hasUnicornQuota">
        <ng-template psUiTableCellTemplate let-quota>
          <div class="empty-group-block">&nbsp;</div>
        </ng-template>
      </ng-container>

      <ng-container psUiTableColumn width="65%">
        <ng-template psUiTableCellTemplate let-quota>
          <div class="flex-wrapper text-center">
            <div
              *ngFor="let eachCombinedKey of quota.combinedKey"
              class="cell-block pl-2"
            >
              {{ eachCombinedKey }}
            </div>
          </div>
        </ng-template>
      </ng-container>

      <ng-container psUiTableColumn width="23%">
        <ng-template psUiTableCellTemplate let-quota>
          <div class="flex-wrapper allocation-group-quota-wrapper">
            <span class="text-center">
              {{ quota.allocation.quantity || 0 }}
            </span>
            <span class="text-center">
              {{ quota.allocation.percentage || 0 | number : '1.0-0' }}%
            </span>
          </div>
        </ng-template>
      </ng-container>

      <ng-container psUiTableColumn width="3%">
        <ng-template psUiTableCellTemplate let-quota>
          <div class="cell-block text-center empty-quota-group-fielded">
            &nbsp;
          </div>
        </ng-template>
      </ng-container>
      <ng-container psUiTableColumn width="2%">
        <ng-template psUiTableCellTemplate let-quota>
          <div class="cell-block text-center empty-quota-group-trash">
            &nbsp;
          </div>
        </ng-template>
      </ng-container>
    </ps-ui-table>
  </div>
</ng-template>
